export class Credentials {
    accessKeyId: string;
    secretAccessKey: string;
    sessionToken: string;
    expireDate: Date;
}


// WEBPACK FOOTER //
// ./src/app/aws/credentials.ts